import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["pathname"];
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import OfferingTypeContext from './context/OfferingTypeContext';
import ModulesRoutes from './modules/ModulesRoutes';
import TemplatesRoutes from './templates/TemplatesRoutes';
// @ts-expect-error module is untyped
import ThemesRoutes from './themes/ThemesRoutes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CatchAllRedirect() {
  const _useLocation = useLocation(),
    {
      pathname
    } = _useLocation,
    restLocation = _objectWithoutPropertiesLoose(_useLocation, _excluded);
  return /*#__PURE__*/_jsx(Switch, {
    children: /*#__PURE__*/_jsx(Redirect, {
      to: Object.assign({}, restLocation, {
        pathname: `/website${pathname}`
      })
    })
  });
}
export default function Routes() {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/website",
      children: /*#__PURE__*/_jsx(OfferingTypeContext.Provider, {
        value: "THEME",
        children: /*#__PURE__*/_jsx(ThemesRoutes, {})
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "/modules",
      children: /*#__PURE__*/_jsx(OfferingTypeContext.Provider, {
        value: "MODULE",
        children: /*#__PURE__*/_jsx(ModulesRoutes, {})
      })
    }), /*#__PURE__*/_jsx(Route, {
      path: "/templates",
      children: /*#__PURE__*/_jsx(TemplatesRoutes, {})
    }), /*#__PURE__*/_jsx(Route, {
      component: CatchAllRedirect
    })]
  });
}